/* import __COLOCATED_TEMPLATE__ from './sh-form.hbs'; */
import { scheduleOnce } from '@ember/runloop';
import Component from '@ember/component';
import $ from 'jquery';
import { computed } from '@ember/object';

export default Component.extend({
  notifyEditActiveSelector: undefined,

  // These options affect the flagChangedOnSave functionality, that adds a class to inputs+labels associated
  // with fields that were saved to the model.
  flagChangedOnSave: false,
  flagChangedOnSaveClass: 'model-changed',
  flagChangedOnSaveDuration: 1500,
  _inputs: undefined,
  _inputsToFlag: undefined,
  _inputsInitialVal: undefined,

  tagName: 'form',
  novalidate: true,
  attributeBindings: ['novalidate', 'action', 'method'],
  classNameBindings: ['editActive:edit-active'],
  method: 'post',
  submitAction: null,
  cancelAction: null,
  isLoading: false,
  errors: {},
  readonly: null,
  showSaveCancel: computed('readonly', 'editCondition', function () {
    return this.get('editCondition') && !this.get('readonly');
  }),
  editActive: computed('readonly', function () {
    return !this.get('readonly');
  }),
  editToggle: computed('readonly', function () {
    return this.get('readonly') ? 'edit' : 'cancelEdit';
  }),
  init() {
    this._super(...arguments);
    scheduleOnce('afterRender', this, function () {
      let readonly = typeof this.get('editCondition') === 'undefined' ? null : true;
      this.set('readonly', readonly);
    });
  },
  submit(e) {
    e.preventDefault();
    let self = this;
    let error = false;

    self.set('errors', {});
    $(this.element).find('[required]').each(function (i, item) {
      let $item = $(item);
      let valid = null;
      if ($item.attr('type') === "checkbox") {
        valid = Boolean($item[0].checked);
      } else {
        valid = Boolean($item.val()) && !$item.hasClass('invalid');
      }
      if (!valid) {
        error = true;
        $item.is('select') ? $item.parents('.select-wrapper').first().addClass('invalid') : $item.addClass('invalid');
      }
    });
    if (!error) {

      let success = function() {
        self.set('isLoading', false);
        self.set('readonly', true);
        let notifyEditActiveSelector = self.get('notifyEditActiveSelector');
        if(notifyEditActiveSelector){
          $(notifyEditActiveSelector).removeClass('edit-active');
        }
        runAfterSave();
      };

      let runAfterSave;
      let flagChangedOnSave = this.get('flagChangedOnSave');

      if(flagChangedOnSave){
        this._setInputsToFlag();
        runAfterSave = () => {
          this._flagInputs();
        };
      } else {
        runAfterSave = () => {
          return;
        };
      }

      if (this.submitAction) {
        // Set isLoading to notify user of submit action
        self.set('isLoading', true);

        const result = this.submitAction();

        // Check to see if the passed-in function returns a "then-able" Promise
        if (result && typeof result.then === 'function') {

          // If the function is then-able, run the appropriate success/fail routines
          result.then( function() {
            success(arguments);
            runAfterSave();
          }, function() {
            //fail(arguments);
          });
        } else {
          // If the submitAction isn't "then-able", report some kind of error
          this.set('isLoading', false);

        }
        
      } else if (this.get('action')) {
        self.set('isLoading', true);
      }
    }
  },
  actions: {
    edit() {
      this.set('readonly', null);
      if(this.get('notifyEditActiveSelector')){
        $(this.get('notifyEditActiveSelector')).addClass('edit-active');
      }
    },
    cancelEdit() {
      let cancelAction = this.get('cancelAction');
      let notifyEditActiveSelector = this.get('notifyEditActiveSelector');

      let rollbackAndReloadModel = () => {
        let model = this.get('model');
        if (model) {
          model.rollbackAttributes();
          // Test for model's current state to avoid attempting model.reload() on non-persisted data.  This
          // is the typical scenario when working with new/unsaved records.
          if(model.get('currentState.stateName') !== 'root.deleted.saved'){
            model.reload().then( () => {
              if(notifyEditActiveSelector){
                $(notifyEditActiveSelector).removeClass('edit-active');
              }
              this.set('readonly', true);
            });
          }
        } else {
          if(notifyEditActiveSelector){
            $(notifyEditActiveSelector).removeClass('edit-active');
          }
          this.set('readonly', true);
        }
      };

      // If cancelAction is set, we send along the rollbackAndReloadModel() function
      // to allow the provided alternative cancelAction to execute the standard functions
      // if it wants.

      if(cancelAction) {
        this.cancelAction(rollbackAndReloadModel);
      } else {
        rollbackAndReloadModel();
      }
    },
    displayErrors(errors) {
      let self = this;
      let tmp = {};
      errors.forEach(function (item) {
        tmp[item.ref] = item.message;
      });
      self.set('errors', tmp);
    },
  },
  didRender() {
    if(!this.get('editActive')){
      return;
    }

    this._setInputsAndInitialValues();
  },


  /**
   * Checks _inputsToFlags for content and if it exists, applies the previously defined flagChangedOnSaveClass
   * to all input/textarea elements and sibling label elements.
   *
   * @private
   */
  _flagInputs() {
    let inputsToFlag = this.get('_inputsToFlag');

    if(inputsToFlag && inputsToFlag.length > 0){
      let flagClass = this.get('flagChangedOnSaveClass');
      let flagDuration = this.get('flagChangedOnSaveDuration');

      let inputsAndLabelsToFlag = inputsToFlag.add(inputsToFlag.siblings('label'));

      inputsAndLabelsToFlag.toggleClass(flagClass, true);
      setTimeout(function() {
        inputsAndLabelsToFlag.toggleClass(flagClass, false);
      }, flagDuration);
    }

    this.set('_inputsToFlag', null);
  },

  /**
   * Checks for any stored inputs from didRender() processes,  and compares their values.  If the inputs' render-time
   * vs current-time values are different, the inputs are added to a jQuery collection and stored in _inputsToFlag.
   *
   * @private
   */
  _setInputsToFlag() {
    let inputs = this.get('_inputs');
    let initialVal = this.get('_inputsInitialVal');

    if(inputs && initialVal && inputs.length > 0 && initialVal.length > 0){
      let inputsToFlag = $([]);

      inputs.each(function(i){
        let input = $( this );
        if(initialVal[i] !== input.val()){
          inputsToFlag = $.merge(inputsToFlag, input);
        }
      });

      this.set('_inputsToFlag', inputsToFlag);
    }
  },

  /**
   * Searches the DOM for all inputs + textareas stored in the form and records their initial values.  Inputs + Values
   * are stored in _inputs and _inputsInitialVal respectively
   *
   * @private
   */
  _setInputsAndInitialValues() {
    let inputs = $(this.element).find('input, textarea');
    let initialVal = [];

    inputs.each(function(i){
      initialVal[i] = $( this ).val();
    });

    this.set('_inputs', inputs);
    this.set('_inputsInitialVal', initialVal);
  }

  // NOTE - If we ever want to track saved values explicitly by the model, we might want to keep this function around.

  /**
   * Checks changedFields and attempts to determine the associated inputs.  Inputs are checked for association
   * by comparing their 'name' attribute to the corresponding model attribute by default, but if a specialProperties
   * object is passed in, it will instead use any modelAttribute/inputElement associations defined in the object first.
   * If only a few of the changed attributes returned by model.changedAttributes() are defined in specialProperties,
   * the function will continue processing each attribute using the default comparison method.
   *
   * @param {object} changedFields - Should be equal to model.changedAttributes() {modelAttr1: [oldContent, NewContent]}
   * @param {object} specialProperties - Should look like {modelAttr1: jqSelectorString1, ...}
   * @private
   */
  // _setInputsToFlag(changedFields, specialProperties) {
  //
  //   let inputs = $('input, textarea');
  //   let inputsToFlag = $([]); //empty JQuery Set
  //
  //   Object.getOwnPropertyNames(changedFields).forEach(function(key, index){
  //
  //     // If passed in specialProperties object contains the changedField,
  //     // add its input to the collection and return instead of checking the other elements
  //     if(specialProperties && typeof specialProperties === 'object' && specialProperties.hasOwnProperty(key)) {
  //       inputsToFlag = Ember.$.merge(inputsToFlag, $(specialProperties[key]));
  //       return;
  //     }
  //
  //     inputs.each(function(inputIndex) {
  //       let inputEl = Ember.$( this );
  //
  //       if(inputEl.attr('name') === key && inputEl.val() === changedFields[key][1]) {
  //         // Remove current Input from collection so it's not checked twice.
  //         inputs.not(inputEl);
  //
  //         inputsToFlag = Ember.$.merge(inputsToFlag, inputEl);
  //         return false;
  //       }
  //     });
  //   }.bind(this));
  //
  //   this.set('_inputsToFlag', inputsToFlag);
  // },




});
